<template>
	<div>
		<h2 class="content-block">Survey Direct Import</h2>
		<div class="content-block">
			<div style="max-width: 720px;">
				<DxTextBox placeholder="Survey Name" v-model:value="surveyName" />
				<div style="margin-top: 0.5em; color: #d9534f; font-weight: bold; font-size: 1.2rem;">
					Note: Survey name should use format abc123 with no spaces or capitals.
				</div>
			</div>
			<div style="margin: 1em 0; max-width:720px;">
				<DxTextArea placeholder="Paste CSV data with header row here" height="240px" v-model:value="csvData" />
				<div style="margin-top: 0.5em; color: #d9534f; font-weight: bold; font-size: 1.2rem;">
					Note: Simple CSV format only with str_getcsv(). A header row MUST be present in the CSV data. Line breaks in the CSV data will break the import.<br>
					Ensure your header row has no spaces including before/after commas. Headers should be formatted like first_name, last_name, etc.<br>
					TODO: It is not clear if this works with JSON true/false values properly.<br>
					TODO: In addition, future surveys might expect {"agree_privacy_policy":true,"agree_cta":true,"survey_from":null} values to be present.
				</div>
			</div>
			<div style="margin: 1em 0; max-width:720px;">
				<DxCheckBox v-model:value="generateRaffle" text="Auto-generate raffle numbers" />
			</div>
			<div>
				<DxButton text="Preview Import" @click="runPreview()" type="default" />
				<DxButton text="Run Import" @click="runImport()" type="danger" style="float:right;" v-if="previewData.length > 0" />
			</div>
			<div v-if="previewData.length > 0" class="importer-preview dx-card">
				<div v-for="(row, index) in previewData" :key="index">
					{{ row  }}
				</div>
			</div>
		</div>
	</div>
</template>

<script setup>
/*eslint-disable*/
import { DxButton } from 'devextreme-vue/button';
import { DxTextArea } from 'devextreme-vue/text-area';
import { DxTextBox } from 'devextreme-vue/text-box';
import DxCheckBox from 'devextreme-vue/check-box';
import { inject, ref } from "vue";

const $http = inject('$http');
const surveyName = ref('');
const csvData = ref('');
const previewData = ref([]);
const generateRaffle = ref(true);

const runPreview = () => {
	$http.post('/survey/import', { preview: 1, name: surveyName.value, data: csvData.value, generate_raffle: generateRaffle.value ? 1 : 0 })
		.then(response => {
			previewData.value = response.data.rows;
		})
		.catch(error => {
			console.error(error);
			alert(error.response.data.message || 'An error occurred while previewing the import.');
		});
}

const runImport = () => {
	$http.post('/survey/import', { preview: 0, name: surveyName.value, data: csvData.value, generate_raffle: generateRaffle.value ? 1 : 0 })
		.then(response => {
			alert('Import completed successfully.');
		})
		.catch(error => {
			console.error(error);
			alert(error.response.data.message || 'An error occurred while importing the survey.');
		});
}

</script>

<style lang="scss">
.importer-preview {
	margin: 1em 0;
	padding: 10px;

	div {
		padding: 2px 10px;
		border-left: 3px solid #999;
		margin-bottom: 2px;
	}
}
</style>
